import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useField, useFormikContext } from 'formik';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button, Label, Slider, Subheading, Title } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import {
	Man1Illustration,
	Man2Illustration,
	Man3Illustration,
	Man4Illustration,
	Man5Illustration,
	Female1Illustration,
	Female2Illustration,
	Female3Illustration,
	Female4Illustration,
	Female5Illustration,
} from '@treams/treams-icons';
import useLocalize from '../../packages/kakapo-ui-application/hooks/useLocalize';

const Axis = styled(Label)<{ start?: boolean; end?: boolean }>``;

export default function Face(props: {
	type: graphql.EngagementType;
	answerTitles?: graphql.LocalizedString[];
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const [{ value }, , { setValue }] = useField('answer.index');
	const [loading, setLoading] = useState(false);
	const formik = useFormikContext();

	const [illustrationRandom] = useState<number>(Math.random());

	const illustrations =
		illustrationRandom > 0.5
			? [Man1Illustration, Man2Illustration, Man3Illustration, Man4Illustration, Man5Illustration]
			: [
					Female1Illustration,
					Female2Illustration,
					Female3Illustration,
					Female4Illustration,
					Female5Illustration,
			  ];

	return (
		<Box width="100%">
			<Title mb={5} textAlign="center">
				<span style={{ fontSize: 64 }}>
					<img height="115" src={illustrations[value ?? 2]} alt="" />
				</span>
			</Title>

			<Box flexGrow={1} width="100%" maxWidth={670}>
				<Slider
					value={(value ?? 2) / (illustrations.length - 1)}
					onChange={(value) => {
						setValue(Math.round(value * (illustrations.length - 1)));
					}}
				/>

				{props.answerTitles && (
					<>
						<Flex mt={3}>
							<Axis flexGrow={0} flexShrink={0} start>
								{localize(props.answerTitles[0]).text}
							</Axis>
							<Box flexGrow={1} flexShrink={1} />
							<Axis flexGrow={0} flexShrink={0} end>
								{localize(props.answerTitles[props.answerTitles.length - 1]).text}
							</Axis>
						</Flex>
						<Flex mt={3} justifyContent="center">
							<Subheading>{localize(props.answerTitles[value ?? 2]).text}</Subheading>
						</Flex>
					</>
				)}
			</Box>

			{value !== undefined && (
				<Flex justifyContent="center">
					<Flex mt={4}>
						<Button
							loading={loading}
							title={t('engagement.respond.face.confirm')}
							onClick={async () => {
								setLoading(true);
								await formik.submitForm();
							}}
						/>
					</Flex>
				</Flex>
			)}
		</Box>
	);
}
